export function Card({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`flex flex-col gap-4 rounded-xl bg-white p-6 shadow-xs border border-gray-200 ${className} w-full`}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children }: { children: React.ReactNode }) {
  return <div className="flex items-center gap-2">{children}</div>;
}

export function CardTitle({ children }: { children: React.ReactNode }) {
  return <div className="leading-none font-semibold tracking-tight">{children}</div>;
}
